import { Icon } from '@/common/components/Icon'
import { Button, Modal } from '@/components/ui'
import { cn } from '@/lib/utils'

export interface CategoryTicket {
  ticketCategoryName: string
  ticketNames: string[]
}

interface SaveConfirmationModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  taxName?: string
  tickets?: CategoryTicket[]
}

export const SaveConfirmationModal = ({
  open,
  onOpenChange,
  onConfirm,
  taxName,
  tickets,
}: SaveConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Modal
      size={tickets && tickets.length > 0 ? 'lg' : 'sm'}
      headerClassName="mb-[37px]"
      contentClassName="p-0 border-2 border-monochrome-120"
      open={open}
      onOpenChange={onOpenChange}
      title={
        <div className="flex items-center gap-2.5">
          <div
            className={cn(
              'h-[44px] w-[44px] rounded-full',
              'bg-monochrome-5 backdrop-blur-md',
              'border-2 border-monochrome-120',
              'flex items-center justify-center',
              'shadow-[0_12px_40px_rgba(0,0,0,0.45)]',
            )}
          >
            <div
              className={cn(
                'h-[40px] w-[40px] rounded-full relative',
                'shadow-[0_0_24px_rgba(136,100%,51%,0.35)]',
                'flex items-center justify-center',
                'text-accent-1',
              )}
            >
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/3 h-1/3 rounded-full bg-gradient-1 blur-md" />
              <Icon
                icon="warning-2"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </div>
          </div>
          <h2 className="text-title-xxs text-monochrome-1 font-bold">
            Save Changes
          </h2>
        </div>
      }
      footerClassName="mt-0 border-t border-monochrome-120 pt-[25px] mt-[25px]"
      footer={
        <div className="flex w-full items-center gap-[15px] justify-end">
          <Button
            onClick={() => onOpenChange(false)}
            variant="secondary"
            className="w-full"
          >
            No
          </Button>
          <Button onClick={handleConfirm} variant="primary" className="w-full">
            Yes, Save Changes
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <div className="text-monochrome-1 text-title-xxs text-center max-w-[500px] mx-auto">
          Are you sure you want to save the changes?
          {taxName && tickets && tickets.length > 0 && (
            <>
              {' '}
              The <span className="text-accent-1">{taxName}</span> is applied on
              following tickets:
            </>
          )}
        </div>
        {tickets && tickets.length > 0 && (
          <div className="flex flex-col gap-3">
            {tickets.map((ticket) => (
              <div key={ticket.ticketCategoryName}>
                <p className="text-monochrome-1 font-bold text-sm">
                  {ticket.ticketCategoryName}
                </p>
                {ticket.ticketNames.map((name) => (
                  <p key={name} className="text-monochrome-2 text-xs">
                    {name}
                  </p>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  )
}
